import React, { useEffect, useMemo, useState } from 'react';
import './PerformancePage.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import ReactApexChart from 'react-apexcharts';
import { Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';

const PerformancePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const username = user.user;

  const [tasks, setTasks] = useState([]);
  const [pendingTaskCount, setPendingTaskCount] = useState(0);
  const [inCompleteTask, setInCompleteTask] = useState([]);
  const [inProcessTaskCount, setInProcessTaskCount] = useState(0);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const [users, setUsers] = useState([]);
  const [totalUser, setTotalUser] = useState(0);

  const [activePeriod, setActivePeriod] = useState('Overall');
  const [employeeSearch, setEmployeeSearch] = useState('');

  const [isIsFormOpenFor_TotalEmployee, setIsIsFormOpenFor_TotalEmployee] = useState(false);
const [isIsFormOpenFor_EmployeeOfMonth, setIsIsFormOpenFor_EmployeeOfMonth] = useState(false);
const [isIsFormOpenFor_EmployeeMostTasksCompleted, setIsIsFormOpenFor_EmployeeMostTasksCompleted] = useState(false);
const [isIsFormOpenFor_TotalPendingTasks, setIsIsFormOpenFor_TotalPendingTasks] = useState(false);

  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        const inComplete = data.filter((task) => task.status === 'Pending');
        setTasks(data);
        setInCompleteTask(inComplete);
      })
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect(() => {
    let pendingcount = 0;
    let inProcessCount = 0;
    let completedCount = 0;

    tasks.forEach((item) => {
      if (item.status === 'Pending') pendingcount += 1;
      else if (item.status === 'In-Process') inProcessCount += 1;
      else if (item.status === 'Completed') completedCount += 1;
    });

    setPendingTaskCount(pendingcount);
    setInProcessTaskCount(inProcessCount);
    setCompletedTaskCount(completedCount);
  }, [tasks]);

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect(() => {
    setTotalUser(users.length);
  }, [users.length]);

  const getUserDetails = (employeeUsername) => {
    const filteredUser = users.filter((item) => item.username === employeeUsername);
    navigate('/IndividualPerformance', { state: { userDetails: filteredUser[0] } });
  };

  const filteredUsers = useMemo(() => {
    const query = employeeSearch.trim().toLowerCase();
    if (!query) return users;

    return users.filter((item) =>
      `${item.username || ''} ${item.role || ''}`.toLowerCase().includes(query)
    );
  }, [users, employeeSearch]);

  const taskTotal = pendingTaskCount + inProcessTaskCount + completedTaskCount;
  const completionRate = taskTotal
    ? Math.round((completedTaskCount / taskTotal) * 100)
    : 0;

  const chartData = {
    series: [pendingTaskCount, inProcessTaskCount, completedTaskCount],
    options: {
      chart: {
        type: 'donut',
        toolbar: { show: false },
        fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
      },
      colors: ['#d95c5c', '#d5a04b', '#4a9b72'],
      labels: ['Pending', 'In-Process', 'Complete'],
      stroke: {
        width: 5,
        colors: ['#ffffff'],
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      plotOptions: {
        pie: {
          donut: {
            size: '78%',
            labels: {
              show: true,
              name: {
                show: true,
                color: '#7b8999',
                fontSize: '11px',
                fontWeight: 700,
                offsetY: -4,
              },
              value: {
                show: true,
                color: '#173452',
                fontSize: '26px',
                fontWeight: 800,
                offsetY: 7,
              },
              total: {
                show: true,
                label: 'Total tasks',
                color: '#7b8999',
                fontSize: '10px',
                fontWeight: 700,
                formatter: () => taskTotal,
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 560,
          options: {
            chart: { height: 250 },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    value: { fontSize: '23px' },
                  },
                },
              },
            },
          },
        },
      ],
    },
  };

  const taskBarState = {
    series: [
      {
        name: 'Tasks',
        data: [pendingTaskCount, inProcessTaskCount, completedTaskCount],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        toolbar: { show: false },
        fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
      },
      colors: ['#173452'],
      plotOptions: {
        bar: {
          borderRadius: 7,
          columnWidth: '42%',
          distributed: false,
        },
      },
      dataLabels: { enabled: false },
      grid: {
        borderColor: 'rgba(23,52,82,0.08)',
        strokeDashArray: 4,
        padding: { left: 8, right: 8 },
      },
      xaxis: {
        categories: ['Pending', 'In-Process', 'Completed'],
        labels: {
          style: { colors: '#8290a1', fontSize: '10px', fontWeight: 600 },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          style: { colors: '#8290a1', fontSize: '10px' },
        },
      },
      tooltip: {
        theme: 'light',
      },
    },
  };

  const ColumnsOf_PerformacePage = [
    {
      title: '#',
      dataIndex: 'Index',
      key: 'Index',
      width: 64,
      render: (value) => <span className="performance_index">{value}</span>,
    },
    {
      title: 'Employee',
      dataIndex: 'Name6',
      key: 'Name6',
      render: (value, record) => (
        <button
          type="button"
          className="employee_name_button"
          onClick={() => getUserDetails(record.Name6)}
        >
          <span className="employee_avatar">
            {(value || '?').slice(0, 1).toUpperCase()}
          </span>
          <span>
            <strong>{value || 'Unknown employee'}</strong>
            <small>View performance profile</small>
          </span>
        </button>
      ),
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      render: (_, { Role }) => (
        <div className="performance_role_group">
          {Role.map((tag) => {
            const roleClass =
              tag === 'Admin' || tag === 'HR'
                ? 'role_primary'
                : tag === 'Manager'
                  ? 'role_manager'
                  : 'role_default';

            return (
              <Tag className={`performance_role_tag ${roleClass}`} key={tag}>
                {tag || '—'}
              </Tag>
            );
          })}
        </div>
      ),
    },
    {
      title: 'Select',
      dataIndex: 'Select',
      key: 'Select',
      width: 84,
      render: () => (
        <label className="modern_checkbox">
          <input type="checkbox" />
          <span />
        </label>
      ),
    },
    {
      title: 'Download',
      dataIndex: 'Download',
      key: 'Download',
      width: 105,
      render: () => (
        <button type="button" className="icon_action" aria-label="Download performance">
          <img src="../assets/download.png" alt="" />
        </button>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 125,
      render: (_, record) => (
        <button
          type="button"
          className="view_more_btn_perfomance"
          onClick={() => getUserDetails(record.Name6)}
        >
          View profile <span>→</span>
        </button>
      ),
    },
  ];

  const dataa = filteredUsers.map((item, index) => ({
    key: item.username || index.toString(),
    Index: index + 1,
    Name6: item.username || '',
    Role: [item.role || ''],
  }));

  const openForm1 = () => setIsIsFormOpenFor_TotalEmployee(true);
  const closeForm1 = () => setIsIsFormOpenFor_TotalEmployee(false);
  const openForm2 = () => setIsIsFormOpenFor_EmployeeOfMonth(true);
  const closeForm2 = () => setIsIsFormOpenFor_EmployeeOfMonth(false);
  const openForm3 = () => setIsIsFormOpenFor_EmployeeMostTasksCompleted(true);
  const closeForm3 = () => setIsIsFormOpenFor_EmployeeMostTasksCompleted(false);
  const openForm4 = () => setIsIsFormOpenFor_TotalPendingTasks(true);
  const closeForm4 = () => setIsIsFormOpenFor_TotalPendingTasks(false);

  const ColumnsOf_TotalEmployee = [
    { title: 'Sr no.', dataIndex: 'Srno', key: 'Srno', width: '20%' },
    { title: 'Name', dataIndex: 'Name2', key: 'Name2' },
  ];

  const dataOf_TotalEmployee = users.map((item, index) => ({
    key: index.toString(),
    Srno: index + 1,
    Name2: `${item.username} (${item.role})`,
  }));

  const ColumnsOf_EmployeeOfMonth = [
    { title: 'Rank', dataIndex: 'Srno2', key: 'Srno2', width: '20%' },
    { title: 'Name', dataIndex: 'Name3', key: 'Name3' },
  ];

  const dataOf_EmployeeOfMonth = [
    { key: '1', Srno2: 1, Name3: '$EmployeeOfMonth' },
    { key: '2', Srno2: 2, Name3: '$EmployeeOfMonth' },
    { key: '3', Srno2: 3, Name3: '$EmployeeOfMonth' },
  ];

  const ColumnsOf_EmployeeMostTasksCompleted = [
    { title: 'Sr no.', dataIndex: 'Srno3', key: 'Srno3', width: '20%' },
    { title: 'Name', dataIndex: 'Name4', key: 'Name4' },
  ];

  const dataOf_EmployeeMostTasksCompleted = [
    { key: '1', Srno3: 1, Name4: '$EmployeeMostTasksCompleted' },
  ];

  const ColumnsOf_TotalPendingTask = [
    { title: 'Sr no.', dataIndex: 'Srno4', key: 'Srno4', width: '20%' },
    { title: 'Name', dataIndex: 'Name5', key: 'Name5' },
    { title: 'Task Details', dataIndex: 'taskDetails', key: 'taskDetails' },
  ];

  const dataOf_TotalPendingTask = inCompleteTask.map((item, index) => ({
    key: index.toString(),
    Srno4: index + 1,
    Name5: item.assignee || '',
    taskDetails: item.taskDetails || '',
  }));

  const renderModal = (open, close, title, columns, data) => {
    if (!open) return null;

    return (
      <>
        <div className="overlay_PerformancePage" onClick={close} />
        <section
          className="popup-form_PerformancePage"
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <header className="performance_modal_header">
            <div>
              <span>Performance overview</span>
              <h3>{title}</h3>
            </div>
            <button type="button" className="close_PerformancePage" onClick={close} aria-label="Close">
              ×
            </button>
          </header>
          <div className="performance_modal_body">
            <Table
              columns={columns}
              dataSource={data}
              scroll={{ y: 420 }}
              pagination={false}
            />
          </div>
        </section>
      </>
    );
  };

  return (
    <div className="performance_page">
      <SideMenuBar />

      <div className="content">
        <NewHeader />

        <main className="performance_container">
          <section className="performance_hero">
            <div>
              <span className="performance_kicker">People analytics</span>
              <h1 className="performance_PerformancePage">Performance</h1>
              <p className="performance_subtitle">
                A focused view of workforce activity, task health and individual performance.
              </p>
            </div>

            <div className="performance_hero_meta">
              <span className="hero_meta_label">Workspace</span>
              <strong>{username.role || 'Employee'}</strong>
              <small>{username.username || 'Current user'}</small>
            </div>
          </section>

          <section className="performance_kpi_grid" aria-label="Performance summary">
            <button type="button" className="performance_kpi_card" onClick={openForm1}>
              <span className="kpi_card_top">
                <span className="kpi_icon kpi_icon_people">PE</span>
                <span className="kpi_more">Open →</span>
              </span>
              <strong>{totalUser}</strong>
              <span>Total employees</span>
              <small>People in your current workspace</small>
            </button>

            <button type="button" className="performance_kpi_card" onClick={openForm2}>
              <span className="kpi_card_top">
                <span className="kpi_icon kpi_icon_star">★</span>
                <span className="kpi_more">Open →</span>
              </span>
              <strong>$123</strong>
              <span>Employee of the month</span>
              <small>Recognition snapshot</small>
            </button>

            <button type="button" className="performance_kpi_card" onClick={openForm3}>
              <span className="kpi_card_top">
                <span className="kpi_icon kpi_icon_tasks">TK</span>
                <span className="kpi_more">Open →</span>
              </span>
              <strong>$123</strong>
              <span>Top task performer</span>
              <small>Highest completed-task signal</small>
            </button>

            <button type="button" className="performance_kpi_card kpi_card_attention" onClick={openForm4}>
              <span className="kpi_card_top">
                <span className="kpi_icon kpi_icon_pending">!</span>
                <span className="kpi_more">Open →</span>
              </span>
              <strong>{pendingTaskCount}</strong>
              <span>Pending tasks</span>
              <small>Items currently needing attention</small>
            </button>
          </section>

          <section className="performance_control_bar">
            <div>
              <span className="section_eyebrow">Reporting period</span>
              <strong>Performance trend</strong>
            </div>

            <div className="period_switcher" role="tablist" aria-label="Reporting period">
              {['Daily', 'Weekly', 'Monthly', 'Overall'].map((period) => (
                <button
                  type="button"
                  role="tab"
                  aria-selected={activePeriod === period}
                  className={activePeriod === period ? 'period_option active' : 'period_option'}
                  onClick={() => setActivePeriod(period)}
                  key={period}
                >
                  {period}
                </button>
              ))}
            </div>
          </section>

          <section className="performance_analytics_grid">
            <article className="performance_panel task_health_panel">
              <header className="performance_panel_header">
                <div>
                  <span className="section_eyebrow">Task health</span>
                  <h2>Current workload</h2>
                </div>
                <span className="panel_metric">{completionRate}% complete</span>
              </header>

              <div className="task_health_content">
                <div className="donut_chart_wrap">
                  <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    height={300}
                  />
                </div>

                <div className="chart_legend">
                  <div><i className="legend_dot pending" /><span>Pending</span><strong>{pendingTaskCount}</strong></div>
                  <div><i className="legend_dot progress" /><span>In-process</span><strong>{inProcessTaskCount}</strong></div>
                  <div><i className="legend_dot complete" /><span>Completed</span><strong>{completedTaskCount}</strong></div>
                </div>
              </div>
            </article>

            <article className="performance_panel task_distribution_panel">
              <header className="performance_panel_header">
                <div>
                  <span className="section_eyebrow">Distribution</span>
                  <h2>Tasks by status</h2>
                </div>
                <span className="panel_metric">{taskTotal} total</span>
              </header>

              <div className="bar_chart_wrap">
                <ReactApexChart
                  options={taskBarState.options}
                  series={taskBarState.series}
                  type="bar"
                  height={300}
                />
              </div>
            </article>
          </section>

          <section className="performance_people_section">
            <header className="performance_section_header">
              <div>
                <span className="section_eyebrow">People</span>
                <h2>Individual performances</h2>
                <p>Open an employee profile to inspect their detailed performance.</p>
              </div>

              <div className="employee_search">
                <span>⌕</span>
                <input
                  type="search"
                  value={employeeSearch}
                  onChange={(event) => setEmployeeSearch(event.target.value)}
                  placeholder="Search employee or role"
                  aria-label="Search employee or role"
                />
                {employeeSearch && (
                  <button type="button" onClick={() => setEmployeeSearch('')} aria-label="Clear search">
                    ×
                  </button>
                )}
              </div>
            </header>

            <div className="performance_table_shell">
              <Table
                className="performance_table"
                columns={ColumnsOf_PerformacePage}
                dataSource={dataa}
                scroll={{ x: 760, y: 430 }}
                pagination={false}
              />
            </div>
          </section>
        </main>
      </div>

      {renderModal(
        isIsFormOpenFor_TotalEmployee,
        closeForm1,
        'Total Employees',
        ColumnsOf_TotalEmployee,
        dataOf_TotalEmployee
      )}

      {renderModal(
        isIsFormOpenFor_EmployeeOfMonth,
        closeForm2,
        'Employee of the Month',
        ColumnsOf_EmployeeOfMonth,
        dataOf_EmployeeOfMonth
      )}

      {renderModal(
        isIsFormOpenFor_EmployeeMostTasksCompleted,
        closeForm3,
        'Employee Most Tasks Completed',
        ColumnsOf_EmployeeMostTasksCompleted,
        dataOf_EmployeeMostTasksCompleted
      )}

      {renderModal(
        isIsFormOpenFor_TotalPendingTasks,
        closeForm4,
        'Total Pending Tasks',
        ColumnsOf_TotalPendingTask,
        dataOf_TotalPendingTask
      )}
    </div>
  );
};

export default PerformancePage;
